/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as VodDraftDefs from "./draftDefs.defs.js";

const $nsid = "place.stream.vod.listDrafts";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"limit":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.integer({"minimum":1,"maximum":100}), 50)),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.jsonPayload({"drafts":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<VodDraftDefs.DraftView>((() => VodDraftDefs.draftView) as any), ),"cursor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** List the authenticated user's draft VODs, newest first. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output);

export { main };

export const $lxm = $nsid;
